module.exports = __webpack_public_path__ + "img/LS-M-10.1742b92a.svg";